import { CheckoutOptimizationAttestationSource } from "@redotech/cockroachdb-codegen/tables/conversion/checkout-optimization-attestation-source";
import { PopulationQualifierKind } from "@redotech/redo-billing-common/checkout-optimization-qualifier";
import * as z from "zod";

const attestationRowSchema = z.object({
  id: z.string(),
  kind: z.nativeEnum(PopulationQualifierKind),
  source: z.nativeEnum(CheckoutOptimizationAttestationSource).nullable(),
  splitId: z.string().nullable(),
  actor: z.string().nullable(),
  note: z.string().nullable(),
  createdAt: z.date().nullable(),
  population: z.string(),
});

const exclusionRowSchema = z.object({
  id: z.string(),
  /** Null suppresses every population qualifier. */
  kind: z.nativeEnum(PopulationQualifierKind).nullable(),
  actor: z.string().nullable(),
  note: z.string().nullable(),
  createdAt: z.date().nullable(),
  population: z.string(),
});

/**
 * One leaf's billing state for the trusted-user editor. `detail` is null
 * unless the caller is trusted — rows carry internal actors and notes.
 */
export const getCheckoutLeafBillingDetail = {
  name: "getCheckoutLeafBillingDetail" as const,
  input: z.object({ checkoutTreeNodeId: z.string() }),
  output: z.object({
    detail: z
      .object({
        population: z.string(),
        observedKinds: z.array(z.nativeEnum(PopulationQualifierKind)),
        attestations: z.array(attestationRowSchema),
        exclusions: z.array(exclusionRowSchema),
        affectedNodeIdsIfExcluded: z.array(z.string()),
        /** Current-window rate per kind; an absent kind bills nothing. */
        qualifierPriceCents: z.array(
          z.object({
            kind: z.nativeEnum(PopulationQualifierKind),
            cents: z.number(),
          }),
        ),
      })
      .nullable(),
  }),
};
